import { render, staticRenderFns } from "./UserLogs.vue?vue&type=template&id=45f0163b&scoped=true"
import script from "./UserLogs.vue?vue&type=script&lang=js"
export * from "./UserLogs.vue?vue&type=script&lang=js"
import style0 from "./UserLogs.vue?vue&type=style&index=0&id=45f0163b&prod&lang=scss&scoped=true"
import style1 from "./UserLogs.vue?vue&type=style&index=1&id=45f0163b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f0163b",
  null
  
)

export default component.exports